import { Severity } from '@iclinic/design-system/dist/components/SnackBar/types';

const getSnackbarPayload = (
  message: string | null = null,
  severity: Severity = 'default',
) => ({ message, severity });

export default getSnackbarPayload;
